export enum ExpertSystemStatus {
    Cancelled = 0,
    DonorOrderSent = 1,
    DonorHlaReceived = 2,
    RecipientOrderSent = 3,
    RecipientHlaReceived = 4,
    ResultsReady = 5,
    PendingDecision = 6,
    Completed = 7,
    DonorNotPaired = 99
}